import { render, staticRenderFns } from "./HotDestinations.vue?vue&type=template&id=40e1a9fe"
import script from "./HotDestinations.vue?vue&type=script&lang=js"
export * from "./HotDestinations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports